import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

// Dashboard por sprint. Si idSprint = null el backend resuelve al semanal
// vigente (o sprint cero como fallback). staleTime corto porque las horas
// asignadas y los conteos cambian con cada edicion de tarea.
export function useDashboard(idSprint: number | null) {
  return useQuery({
    queryKey: ['dashboard', idSprint],
    queryFn: () => api.dashboard.get(idSprint ?? undefined),
    staleTime: 30 * 1000,
  });
}
